import { useState, useEffect } from "react";
import { ArrowUp } from "lucide-react";

/**
 * Back-to-top button that fades in after user scrolls past 50% of the page.
 * Provides navigation help on long pages (11 000+ px startsida).
 */
export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPercent = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight);
      setVisible(scrollPercent > 0.25);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-20 lg:bottom-8 right-4 lg:right-6 z-40 w-11 h-11 rounded-full bg-navy/90 text-white shadow-lg hover:bg-navy hover:scale-110 transition-all duration-200 flex items-center justify-center backdrop-blur-sm"
      aria-label="Tillbaka till toppen"
      title="Tillbaka till toppen"
    >
      <ArrowUp className="w-5 h-5" />
    </button>
  );
}
